import { useState, useCallback, useEffect } from 'react';
import { SelectItemProps } from '@ui/src';
import { useLazyGetConfigurationAccountsQuery } from '../service';
import { Account } from '../types';

interface ListResponse {
  data: { data: { edges: { node: Account }[] } };
}

let timeout: NodeJS.Timeout;

const useGetAutocompleteList = (id?: string) => {
  const [autocompleteList, setAutocompleteList] = useState<SelectItemProps[]>(
    [],
  );

  const [getList, { isFetching, isLoading }] =
    useLazyGetConfigurationAccountsQuery();

  const getAutocompleteListAction = useCallback(async (query?: string) => {
    const results: SelectItemProps[] = [];

    const response = (await getList(
      `?take=40&fullNumber=4.0.${query ? `&search=${query}` : ''}${
        !id ? '&closed=false' : ''
      }`,
    )) as ListResponse;

    if (response?.data?.data) {
      response.data.data.edges?.forEach((item) => {
        const result: SelectItemProps = {
          name: '',
          description: '',
          value: item.node.fullNumber,
        };

        if (item.node.description && item.node.fullNumber) {
          result.name = item.node.description;
          result.suffix = item.node.fullNumber;
        } else if (!item.node.clientName) {
          result.name = item.node.fullNumber;
        }

        results.push(result);
      });
    }

    setAutocompleteList(results);
  }, []);

  const onSearch = (query: string) => {
    clearTimeout(timeout);

    timeout = setTimeout(() => {
      getAutocompleteListAction(query);
    }, 500);
  };

  useEffect(() => {
    getAutocompleteListAction();
  }, [getAutocompleteListAction]);

  return {
    getAutocompleteListAction,
    accounts: autocompleteList,
    onSearch,
    isLoading,
    isFetching,
  };
};

export default useGetAutocompleteList;
